export const
    CONNECTION_DEFAULT_TIMEOUT = 10000,
    CONNECTION_MAX_RETRIES= 5,
    CONNECTION_RETRY_DELAY= 2000,
    appLanguages = ["en", "es", "ca"];
